<template>
  <el-card class="box-card full-screen batch-operation-review">
    <el-page-header @back="$router.go(-1)" :title="$t('Back')">
      <template slot="content"
        ><span style="font-size:14px"
          >{{ $t("remittanceBusiness") }} / {{ $t("batchTransactionHistory") }}</span
        ></template
      >
    </el-page-header>
  
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('businessName')">
          <el-select
            v-model="queryForm.businessCode"
            size="small"
            :placeholder="$t('all')"
            clearable
            style="width:200px"
          >
            <el-option
              v-for="op in operations"
              :key="op.code"
              :label="$t(op.label)"
              :value="op.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            size="small"
            :placeholder="$t('all')"
            clearable
            style="width:160px"
          >
            <el-option :label="$t('trading')" :value="1"></el-option>
            <el-option
              :label="$t('completeTransaction')"
              :value="2"
            ></el-option>
            <el-option :label="$t('failureTransaction')" :value="3"></el-option>
            <el-option :label="$t('completeReversal')" :value="5"></el-option>
            <el-option :label="$t('failureReversal')" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('region')">
          <el-select
            v-model="queryForm.region"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <!-- 国 -->
            <template v-for="(item, i) in countryList">
              <el-option-group
                v-if="item.parentId == 0"
                :key="i"
                :label="$t(item.name)"
              >
                <!-- 省 -->
                <template v-for="(t, i) in countryList">
                  <el-option
                    v-if="t.parentId == item.id"
                    :key="i"
                    :label="$t(t.name)"
                    :value="t.id"
                  ></el-option>
                </template>
              </el-option-group>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
          <el-button size="small" @click="onReset">{{ $t("reset") }}</el-button>
        </el-form-item>
      </el-form>
      <el-row class="table-btns">
        <a @click="downloadEXCEL()" type="text" size="mini"
          ><i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}</a
        >
      </el-row>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="applyCode"
          :label="$t('transactionInfoId')"
          fixed="left"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="account"
          :label="$t('transaction account')"
          fixed="left"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="tranType"
          :label="$t('dealType')"
          fixed="left"
          width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.tranType == 1">{{
              $t("batchOfRemittance")
            }}</span>
            <span v-else-if="scope.row.tranType == 2">{{
              $t("batchTransferAccounts")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('transactionAmount')"
          width="140"
        >
          <template slot-scope="scope">
            <span class="franc">FCFA</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="excelName"
          :label="$t('transaction EXCEL name')"
          show-overflow-tooltip
          width="200"
        ></el-table-column>
        <el-table-column
          prop="payeeCityId"
          :label="$t('beneficiariesAddress')"
          width="160"
        >
          <template slot-scope="scope">
            {{ getCityFullName(scope.row.payeeCityId) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('transaction time')"
          width="140"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createTime).format("ymdhms") }}
          </template>
        </el-table-column>

        <!-- 、0待审核 1审核通过 2审核失败(大客户只需要自己财务+自己经理审核，这里加了一个审核状态) -->
        <el-table-column
          v-if="loginInfo.type == 'customerLogin'"
          prop="checkStatus"
          :label="$t('checkStatus')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.checkStatus == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-else-if="scope.row.checkStatus == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-else-if="scope.row.checkStatus == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <!-- 、0待审核 1审核通过 2审核失败 -->
        <el-table-column
          v-else
          prop="status"
          :label="$t('checkStatus')"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-else-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-else-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="140"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTime">{{
              $manba(scope.row.verifyTime).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemark"
          :label="$t('checkRemark') + 1"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column
          prop="checkRemark"
          :label="$t('checkRemark') + 2"
          show-overflow-tooltip
          width="200"
        />
        <el-table-column :label="$t('extend')" fixed="right" width="340">
  <template slot-scope="scope">
    <el-button size="mini" @click.stop="showDrawerRowExcel(scope.row)">
      {{ $t("detailedInfo") }}
    </el-button>
    <el-button
      size="mini"
      type="primary"
      :disabled="scope.row.status != 1"
      @click.stop="openPrint(scope.row)"
    >
      {{ $t("printrRceipt") }}
    </el-button>
  </template>
</el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :visible.sync="drawerRowExcel"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      size="1200px"
    >
      <template #title>
        <span v-if="selectedRows.tranType == 1">{{
          $t("Batch remittance review")
        }}</span>
        <span v-if="selectedRows.tranType == 2">{{
          $t("Batch transfer review")
        }}</span>
      </template>
      <el-collapse v-model="collapseActiveNames">
        <el-collapse-item :title="$t('transaction info')" name="1">
          <el-row class="jiaoyirenxx">
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("transaction account") }}：</strong>
              <div>{{ selectedRows.account }}</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("accountType") }}：</strong>
              <div v-if="selectedRows.accountType == 5">
                {{ $t("individualAccount") }}
              </div>
              <div v-else-if="selectedRows.accountType == 6">
                {{ $t("companyAccount") }}
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("dealType") }}：</strong>
              <div v-if="selectedRows.tranType == 1">
                {{ $t("batchOfRemittance") }}
              </div>
              <div v-else-if="selectedRows.tranType == 2">
                {{ $t("batchTransferAccounts") }}
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("transactionAmount") }}：</strong>
              <div v-if="selectedRows.amount">
                <span class="franc">FCFA</span
                >{{ selectedRows.amount.formatMoney(0) }}
              </div>
              <div v-else><span class="franc">FCFA</span>--</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("transaction EXCEL name") }}：</strong>
              <div>{{ selectedRows.excelName }}</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("transaction time") }}：</strong>
              <div>{{ $manba(selectedRows.createTime).format("ymdhms") }}</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("reason2") }}：</strong>
              <div>{{ selectedRows.casue }}</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="6">
              <strong>{{ $t("beneficiariesAddress") }}：</strong>
              <div>
                {{ getCityFullName(selectedRows.payeeCityId) }}
              </div>
            </el-col>
            <el-col :xs="24">
              <strong>{{ $t("transactionRemark") }}：</strong>
              <div>{{ selectedRows.remark }}</div>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item :title="$t('proceeds info list')" name="2">
          <!-- 转账EXCEL模板 -->
          <el-table
            v-if="selectedRows.tranType == 2"
            :data="rowExcelData"
            size="mini"
            max-height="500px"
            v-loading="isItemLoading"
          >
            <el-table-column
              prop="cardNo"
              :label="$t('cardNo')"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="idCard"
              :label="$t('idCard')"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="phone"
              :label="$t('phone')"
              width="100"
            ></el-table-column>
            <el-table-column prop="amount" :label="$t('amount')" width="100">
              <template slot-scope="scope">
                <span class="franc">FCFA</span
                >{{ scope.row.amount.formatMoney(0) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="payeeCityId"
              :label="$t('beneficiariesAddress')"
              width="160"
            >
              <template slot-scope="scope">
                {{ getCityFullName(scope.row.payeeCityId) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="applyRemark"
              :label="$t('remark')"
            ></el-table-column>
          </el-table>
          <!-- 汇款EXCEL模板 -->
          <el-table
            v-else-if="selectedRows.tranType == 1"
            :data="rowExcelData"
            size="mini"
            max-height="500px"
            v-loading="isItemLoading"
          >
            <el-table-column
              prop="name"
              :label="$t('firstName')"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="surname"
              :label="$t('lastName')"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="idCard"
              :label="$t('idCard')"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="phone"
              :label="$t('phone')"
              width="100"
            ></el-table-column>
            <el-table-column prop="amount" :label="$t('amount')" width="100">
              <template slot-scope="scope">
                <span class="franc">FCFA</span
                >{{ scope.row.amount.formatMoney(0) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="remark"
              :label="$t('remark')"
            ></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>

    <el-dialog
  :title="$t('printrRceipt')"
  :visible.sync="printVisible"
  width="600px"
  :modal-append-to-body="false"
  :destroy-on-close="true"
  :close-on-press-escape="false"
  :close-on-click-modal="false"
>
  <print-credentials
    v-if="printParam"
    :param="printParam"
    :isClosePrint.sync="printVisible"
  />
</el-dialog>
  </el-card>
</template>

<script>
import batchApply from "@/api/batchApply";
import customerBusiness from "@/api/customerBusiness";
import qs from "qs";
import printCredentials from "@/components/printCredentials";

export default {
  components: { printCredentials },
  name: "batchTransactionHistory",
  data() {
    return {
      queryForm: {        date: null,
        businessCode: "",
        status: null,},
        operations: [
        { code: "70", label: "transferAccounts" },
        { code: "71", label: "batchTransferAccounts" },
        { code: "72", label: "accountRemittanceNotAccount" },
        { code: "73", label: "batchOfRemittance" },
      ],
      //table高度，动态设置
      queryTableHeight: String,
      printVisible: false,
      printParam: null,
      //table显示内容
      tableData: {},
      isLoading: false,
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,

      //显示行对应的EXCEL列表
      isItemLoading: false,
      selectedRows: {},
      drawerRowExcel: false,
      rowExcelData: [],
      collapseActiveNames: ["1", "2"],
     
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cascader() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    downloadUrl() {
      let param = JSON.parse(JSON.stringify(this.queryForm));
      return customerBusiness.advancedCustomerTranExport + "?" + qs.stringify(param);
    },
  },
  methods: {
    
    /*getList() {
      let _this = this;
      this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      if (this.loginInfo.type == "customerLogin") {
        customerBusiness.pageBatchApply({
          param: {
            current: this.currentPage,
            size: this.pageSize,
            ...this.queryForm,
          },
          success: (res) => {
            this.tableData = res.data || {};
            this.isLoading = false;
          },
        });
      } else {
        batchApply.getPage({
          param: {
            current: this.currentPage,
            size: this.pageSize,
            ...this.queryForm,
          },
          success: (res) => {
            this.tableData = res.data || {};
            this.isLoading = false;
          },
        });
      }
    },
    */
    getList() {
  this.isLoading = true;

  const params = { ...this.queryForm };
  if (params.date && params.date.length === 2) {
    params.startTime = this.$manba(params.date[0]).format("ymd");
    params.endTime   = this.$manba(params.date[1]).format("ymd");
  }
  delete params.date;

  const payload = {
    current: this.currentPage,
    size: this.pageSize,
    ...params,
  };

  const api = this.loginInfo.type === "customerLogin"
    ? customerBusiness.pageBatchApply
    : batchApply.getPage;

  api({
    param: payload,
    success: (res) => {
      this.tableData = res.data || {};
      this.isLoading = false;
    },
    failing: () => {
      this.isLoading = false;
    },
  });
},
onReset() {
  this.queryForm = {
    date: null,
    businessCode: "",
    status: null,
    region: "",
  };
  this.currentPage = 1;
  this.getList();
},
    downloadEXCEL() {
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    query() {
      this.$set(this, "currentPage", 1);
      this.$set(this, "tableData", {});
      this.getList();
    },
    getCityFullName(cityId) {
      if (!cityId || !this.countryList.length) return "-";

      const city = this.countryList.find((c) => c.id == cityId);
      if (!city) return "-";

      const region = this.countryList.find((c) => c.id == city.parentId);

      const country = region
        ? this.countryList.find((c) => c.id == region.parentId)
        : null;

      return [country, region, city]
        .filter(Boolean)
        .map((c) => c.name)
        .join(" / ");
    },
    getRegionName(arr) {
      let name = "";
      for (let i in arr) {
        let tt = this.countryList.find(function(t) {
          return t.id == arr[i];
        });
        name += tt ? tt.name + " " : "";
      }
      return name.substring(0, name.length - 1);
    },

    showDrawerRowExcel(item) {
      this.$set(this, "isItemLoading", true);
      if (this.loginInfo.type == "customerLogin") {
        customerBusiness.pageBatchRemittanceTransferImport({
          param: { excelName: item.excelName, size: -1 },
          success: (res) => {
            this.$set(this, "rowExcelData", res.data?.records);
            this.$set(this, "isItemLoading", false);
          },
        });
      } else {
        batchApply.pageBatchRemittanceTransferImport({
          param: { excelName: item.excelName, size: -1 },
          success: (res) => {
            this.$set(this, "rowExcelData", res.data?.records);
            this.$set(this, "isItemLoading", false);
          },
        });
      }

      this.$set(this, "selectedRows", item);
     
      this.drawerRowExcel = true;
    },


      openPrint(row) {
  const api = this.loginInfo.type === "customerLogin"
    ? customerBusiness.pageBatchRemittanceTransferImport
    : batchApply.pageBatchRemittanceTransferImport;

  api({
    param: { excelName: row.excelName, size: -1 },
    success: (res) => {
      const details = (res.data && res.data.records) || [];
      const totalFee = details.reduce(
        (s, d) => s + Number(d.serviceChargeAmount || 0), 0);

      this.printParam = {
    remittorName:          (row.applyUser || "").split(" ")[0] || "",
    remittorSurname:       (row.applyUser || "").split(" ").slice(1).join(" "),
    remittorCardNo:        row.account,
    payeeCity:             this.getCityFullName(row.payeeCityId),
    purpose:               row.casue,
    dateTime:              row.createTime,
    businessType:          this.businessLabel(row.businessCode),
    amount:                Number(row.amount || 0),
    transactionCode:       row.applyCode,
    orgInfoName:           row.verifyUser || "",
    serviceChageAmout: totalFee,
      };
      this.printVisible = true;
    },
  });

},

businessLabel(code) {
  const op = this.operations.find((o) => o.code === String(code));
  return op ? this.$t(op.label) : code;
},
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    if (!this.countryList || this.countryList.length === 0) {
      this.$store.dispatch("globalParameter/getCountry");
    }
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.functional-zone {
  margin-top: 20px;
  /deep/.el-radio {
    margin-right: 0;
  }
  /deep/.el-form-item:last-child {
    .el-form-item__label {
      height: 32px;
    }
  }
  /deep/.el-form-item:nth-child(2) {
    width: 40%;
  }
}
.jiaoyirenxx {
  .el-col {
    margin: 5px 0;
    div {
      color: #999;
    }
  }
}
/deep/.el-collapse-item__header {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.table-btns a {
  cursor: pointer;
}
</style>
